import './FileUploadStatus.scss';

export { default } from './FileUploadStatus';
